import React from 'react';
import PropTypes from 'prop-types';

import styles from 'styles/components/account/subscriptions/subscriptionListItem.scss';

const EmailListSubscriptionListItem = ({ emailListName, subscribed, onListChange }) => {
  const id = emailListName.replace(/ /g, '');

  return (
    <tr className={styles.rowBackgroundEven}>
      <td>
        <input
          name={id}
          id={id}
          checked={subscribed}
          value={emailListName}
          onChange={onListChange}
          type="checkbox"/>
        <label htmlFor={id}>
          {emailListName}
        </label>
      </td>
    </tr>
  );
};

EmailListSubscriptionListItem.propTypes = {
  emailListName: PropTypes.string.isRequired,
  subscribed: PropTypes.bool.isRequired,
  onListChange: PropTypes.func.isRequired
};

export default EmailListSubscriptionListItem;
